(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const mediaItems = new Set();

  function update(media) {
    const video = media.querySelector('video');
    if (!video) return;
    if (media.dataset.visible === 'true' && !reducedMotion.matches && !document.hidden) {
      video.play().then(() => media.classList.add('is-playing')).catch(() => {
        media.classList.remove('is-playing');
      });
    } else {
      video.pause();
      media.classList.remove('is-playing');
    }
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.dataset.visible = entry.isIntersecting ? 'true' : 'false';
        update(entry.target);
      });
    }, { threshold: 0.3 })
    : null;

  function initialize(root = document) {
    root.querySelectorAll('[data-bb-how-video]:not([data-bb-how-video-ready])').forEach((media) => {
      const video = media.querySelector('video');
      if (!video) return;
      media.dataset.bbHowVideoReady = 'true';
      video.muted = true;
      if (media.dataset.poster) video.poster = media.dataset.poster;
      mediaItems.add(media);
      observer?.observe(media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-bb-how-video]').forEach((media) => {
      media.querySelector('video')?.pause();
      observer?.unobserve(media);
      mediaItems.delete(media);
    });
  });
  document.addEventListener('visibilitychange', () => mediaItems.forEach(update));
  reducedMotion.addEventListener('change', () => mediaItems.forEach(update));
})();
